<template>
    <section class="row px-4 py-2 pb-0 g-0" v-if="isTagsEnabled">
        <div class="col-12 offset-lg-1 col-lg-10 mb-1 row g-0">
            <div class="form-group col-12 pe-lg-2">
                <label for="patient-tags"> Tags </label>
                <TagsInput
                    :data="patientTags"
                    :tags="selectedTags"
                    v-on:updateTags="updateTags"
                    placeholder="Start Typing..."
                    :open-on-focus="true"
                    v-custom-popover="sanitizeMarkup(tagsTooltip)"
                />
            </div>
        </div>
    </section>
</template>

<script lang="ts" src="./PatientTags.ts"></script>
